<script lang="ts" generics="Locale extends string">
	import arrowDown from "../../../core/assets/icons/arrow-down.svg?raw";
	import Icon from "./Icon.svelte";
	import Link from "./Link.svelte";

	export let tenants: { locale: Locale; prefix: string }[];
	export let webUrl: string;
	export let pageSlug: Partial<Record<NoInfer<Locale>, string>>;
	export let currentLocale: NoInfer<Locale>;

	let isLanguageListOpen = false;
	let containerRef: HTMLElement;

	function localeLabel(locale: string): string {
		return locale === "cs" ? "CZ" : locale.toUpperCase();
	}

	function toggleLanguageList(): void {
		isLanguageListOpen = !isLanguageListOpen;
	}

	// pointerdown instead of click: iOS Safari doesn't dispatch click on non-interactive elements.
	function onWindowPointerDown(e: PointerEvent): void {
		if (isLanguageListOpen && !e.composedPath().includes(containerRef)) {
			isLanguageListOpen = false;
		}
	}
</script>

<svelte:window on:pointerdown={onWindowPointerDown} />

<div bind:this={containerRef} class="group relative">
	<button
		type="button"
		class="flex h-12 items-center gap-1 text-sm font-semibold text-white"
		aria-expanded={isLanguageListOpen}
		on:click={toggleLanguageList}
	>
		{localeLabel(currentLocale)}
		<Icon
			icon={arrowDown}
			class="size-5 transition-transform duration-300 ease-in-out [@media(hover:hover)]:group-hover:rotate-180 {isLanguageListOpen
				? 'rotate-180'
				: ''}"
		/>
	</button>
	<div
		class="absolute left-1/2 top-[calc(100%+.25rem)] w-fit -translate-x-1/2 rounded-lg bg-white shadow-sm transition-opacity duration-300 ease-in-out after:absolute after:inset-x-0 after:-top-1 after:h-1 after:w-full after:content-[''] [@media(hover:hover)]:group-hover:pointer-events-auto [@media(hover:hover)]:group-hover:opacity-100 {isLanguageListOpen
			? 'pointer-events-auto opacity-100'
			: 'pointer-events-none opacity-0'}"
	>
		{#each tenants as tenant}
			{#if tenant.locale !== currentLocale}
				<Link
					class="hover:!text-ltprimary-300 !block w-full rounded-lg bg-white px-3 py-2 text-center text-sm !text-black transition-colors duration-300 ease-in-out"
					noUnderline
					iconGap="mr-0"
					href="{webUrl}/{pageSlug[tenant.locale] ?? tenant.prefix.slice(1)}"
				>
					{localeLabel(tenant.locale)}
				</Link>
			{/if}
		{/each}
	</div>
</div>
